import React, { useContext, useEffect } from 'react';
import AuthProvider, { AuthContext } from './AuthContext';
import RequireEmailModal from './Components/RequireEmailModal';
import { CategoryProvider } from './CategoryContext';
import { LocationsProvider } from './LocationsContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute';
import TopNavbar from './Components/TopNavbar';
import Home from './Pages/Home';
import Kategorije from './Pages/Categories';
import VsiOglasi from './Pages/AllAds';
import Footer from './Components/Footer';
import Login from './Pages/Login';
import ForgotPasswordPage from './Pages/ForgotPassword';
import ResetPasswordPage from './Pages/ResetPasswordPage';
import ConfirmEmail from './Pages/ConfirmEmail';
import UserDashboard from './Components/UserDashboard/UserDashboard';
import AdDetails from './Pages/AdDetails';
import PostAd from './Pages/PostAd';
import AllUserAds from './Pages/AllUserAds';
import EditAd from './Pages/EditAd';
import { ScrollRestorer } from './Components/ScrollToTop';
import AboutUs from './Pages/AboutUs';
import FAQ from './Pages/FAQ';
import TermsPage from './Pages/TermsPage';
import PrivacyPolicyPage from './Pages/PrivacyPolicyPage';
import CookiePolicyPage from './Pages/CookiePolicyPage';
import ContactPage from './Pages/ContactPage';
import FeedbackPage from './Pages/FeedbackPage';
import MissionPage from './Pages/MissionPage';
import SellingTipsPage from './Pages/SellingTipsPage';
import { FaPlus } from 'react-icons/fa'; // Uporabimo ikono za gumb
//import PriceGuessGame from './Components/PriceGuessGame/PriceGuessGame'; // Če bo kdaj igra vpravljena v App.js
import './App.css';
import AdminRoute from './Components/AdminRoute';
import AdminLayout from './Pages/Admin/AdminLayout';
import AdminDashboard from './Pages/Admin/AdminDashboard';
import ManageUsers from './Pages/Admin/ManageUsers';
import ManageListings from './Pages/Admin/ManageListings';
import ReportedListings from './Pages/Admin/ReportedListings';
import ManageCategories from './Pages/Admin/ManageCategories';
import BlogIndexPage from './Pages/BlogIndexPage';
import BlogPostPage from './Pages/BlogPostPage';
import ManageBlog from './Pages/Admin/ManageBlog';
import ModerationQueue from './Pages/Admin/ModerationQueue';


function AppContent() {
  //const [isGameOpen, setIsGameOpen] = useState(false); // Če bo kdaj igra vpravljena v App.js
  // --- NOVO: GLOBALNI PREVERJALNIK ZA PREUSMERITEV PO LOGINU ---
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Ta koda se izvede vsakič, ko se spremeni "user" (torej ko se prijavi)
    if (user) {
      // Preverimo, če v shrambi čaka kakšna preusmeritev (npr. /objavi-oglas)
      const redirectPath = localStorage.getItem('loginRedirect');

      if (redirectPath) {
        // === POPRAVEK TUKAJ ===
        // Preverimo, ali smo MORDDA ŽE na tej strani.
        // Če smo, potem NE navigiramo ponovno, da ne prekinemo procesov (kot je oddaja oglasa).
        if (window.location.pathname !== redirectPath) {
          navigate(redirectPath);
        }
        // Počistimo shrambo v vsakem primeru
        localStorage.removeItem('loginRedirect');
      }
    }
  }, [user, navigate]);

  return (
    <>
      <TopNavbar />
      <RequireEmailModal />
      <ScrollRestorer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pozabljeno-geslo" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/confirm-email/:token" element={<ConfirmEmail />} />
        <Route path="/kategorije" element={<Kategorije />} />
        <Route path="/oglasi" element={<VsiOglasi />} />
        <Route path="/oglasi-uporabnika/:user_id" element={<AllUserAds />} />
        <Route path="/prijava" element={<Login />} />
        <Route path="/oglas/:slug/:id" element={<AdDetails />} />

        <Route
          path="/moj-racun/:tab?"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/objavi-oglas"
          element={
            <PostAd />
          }
        />
        <Route
          path="/uredi-oglas/:slug/:id"
          element={
            <ProtectedRoute>
              <EditAd />
            </ProtectedRoute>
          }
        />

        <Route path="/about" element={<AboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/mission" element={<MissionPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/selling-tips" element={<SellingTipsPage />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />

        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="listings" element={<ManageListings />} />
          <Route path="reports" element={<ReportedListings />} />
          <Route path="moderation-queue" element={<ModerationQueue />} />
          <Route path="categories" element={<ManageCategories />} />
          <Route path="blog" element={<ManageBlog />} />
        </Route>

        <Route path="*" element={<h1>Stran ne obstaja (404 Not Found)</h1>} />

      </Routes>
      <Footer />
      <button
        className="cta-fab pulsing-fab"
        onClick={() => navigate('/objavi-oglas')}
        title="Objavi oglas"
        data-umami-event="FAB Objavi oglas"
      >
        <FaPlus />
      </button>

      {/* --- KOMPONENTA ZA IGRO --- */}
      {/* <PriceGuessGame
        isOpen={isGameOpen}
        onClose={() => setIsGameOpen(false)}
      />
      */}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <CategoryProvider>
        <LocationsProvider>
          <Router>
            <AppContent />
          </Router>
        </LocationsProvider>
      </CategoryProvider>
    </AuthProvider>
  );
}

export default App;